import { motion } from 'framer-motion'
import styled from 'styled-components'
import { MediaBreakPointUp } from '~/theme'
import { SwitchIcon } from '~/components/icons'

export const InputGroup = styled.div`
  flex: 1;
`

export const LabelWrapper = styled.span`
  color: ${({ theme }) => theme.colors.textStrong};
  font-size: 13px;
  font-weight: 400;
  line-height: 140%;
`

export const StyledLabelTokenInfo = styled.label`
  color: ${({ theme }) => theme.colors.textCaption};
`

export const InputWrapper = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.borderInput};
  border-radius: 56px;
  display: flex;
  flex-direction: row;
  height: 46px;
  justify-content: space-between;
  margin-top: 8px;
  padding: 10px 7.5px 10px 5px;
`

export const OutputRateWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const StyledRateWithUSDWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-end;
  position: relative;
`

export const StyledRateWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const StyledRateUSD = styled.div`
  position: absolute;
  top: 18.2px;
  right: 0;
  color: ${({ theme }) => theme.colors.textTertiary};
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
`

export const Input = styled.input`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.textStrong};
  font-size: 13px;
  font-weight: 400;
  line-height: 140%;
  outline: none;
  text-align: right;
  width: 100%;
  padding: 0;

  ::-webkit-input-placeholder {
    color: #b2b5cc;
    font-weight: 400;
    font-size: 13px;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media screen and (max-width: ${MediaBreakPointUp.sm}) {
    font-size: 12px;

    ::-webkit-input-placeholder {
      font-size: 12px;
    }
  }

  /* Firefox */

  -moz-appearance: textfield;
`

export const InputHelpText = styled.div`
  flex: none;
  color: ${({ theme }) => theme.colors.textStrong};
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.242667px;
  line-height: 17px;
  height: 17px;
  margin: 0px 4px;

  @media screen and (max-width: ${MediaBreakPointUp.sm}) {
    font-size: 12px;
  }
`

export const ConvertIcon = styled(SwitchIcon)`
  width: 14px;
  height: 14px;
  cursor: pointer;

  ${({ theme }) => theme.media.sm`
    margin: 0 4px;
  `}
`
export const RefreshIcon = styled(motion.img)`
  cursor: pointer;
`
